import { UtilizadorSessao } from "../../aplicacao/utilizador-sessao";

export class ArtigoFiltros {
    constructor(
        public IdClassificacao?: number,
        public CodIdioma?: string,
        public CodArtigo?: string,
        public IdTiposArtigo?: number[],
        public Descricao?: string,
        public IdEstado?: number[],
        public IdUnidade?: number[],
        public Marcacao?: boolean[],
        public ValorMinMoeda1?: number,
        public ValorMaxMoeda1?: number,
        public ValorMinMoeda2?: number,
        public ValorMaxMoeda2?: number,
        public DataInicio?: string,
        public DataFim?: string,
        public Imagem?: boolean[],
        public renovavel?: boolean,
        public utilizadorSessao?: UtilizadorSessao
    ) {
    }
}
